export default "//static.tradera.net/touchweb/static/output/images/google-play-badge-fr.a1d9eaac.png";